import React from "react";
import "./Form.scss";

interface FormProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

const Form = React.forwardRef<HTMLDivElement, FormProps>(({ children, className, ...props }, ref) => {
    return (
        <div className={`userful-form ${className || ""}`} ref={ref} {...props}>
            {children}
        </div>
    );
});

Form.displayName = "Form";

export default Form;
